import styled from '@emotion/styled';
import { getSpace, GridContainer } from '../../../../../ui/index.ts';

export const Container = styled(GridContainer)`
  padding: ${getSpace('20')} ${getSpace('28')};
`;
